import { InsurancePolicyService } from 'src/app/shared/services/insurance-policy.service';
import dayjs from 'dayjs';
import { Injectable, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { InsuranceclaimsClass } from 'src/app/shared/models/insuranceclaims-class';
import { InsurancePolicyClass } from 'src/app/shared/models/insurancesPolicy-class';
import { CustomerService } from 'src/app/shared/services/customer.service';
import { InsuranceclaimsService } from 'src/app/shared/services/insurance-claims.service';
import { SafesimulationsClass } from 'src/app/shared/models/safesimulations-class';
import { SafesimulationsService } from 'src/app/shared/services/safesimulations.service';
import { Alert } from 'src/app/shared/models/alert-class';
import { MatDrawer } from '@angular/material/sidenav';
import { MatDialog } from '@angular/material/dialog';
import { FilesClass, UploadFilesClass } from 'src/app/shared/models/uploads-class';
import { environment } from 'src/environments/environment';
// import { DocumentsComponent } from 'src/app/shared/components/documents/documents.component';
import Swal from './swal-compat';
import { AuthService } from 'src/app/shared/services/auth.service';
import { GlobalService } from './global.service';
import { AgeasService } from './ageas.service';
import { ProductsService } from './products.service';
import { ProductsTypesClass } from '../models/products-class';
// import { QivOnlineComponent } from 'src/app/pages/clientarea/insuranceclaims/qiv-online/qiv-online.component';
import { CommonService } from './common.service';
import { CustomerClass } from '../models/customer-class';
// import { InsuranceclaimsformComponent } from '../components/insuranceclaimsform/insuranceclaimsform.component';
// import { InsuranceClaimNotificationComponent } from 'src/app/pages/clientarea/insuranceclaims/insurance-claim-notification/insurance-claim-notification.component';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { AlertMessageService } from './alert-message.service';
import { NetworkStatusService } from './network-status.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ClientareaService {
  @ViewChild('options') options: MatDrawer;

  showProgressWginsurancepolicy: boolean;
  showWgsafesimulationsshowProgress: boolean;
  showWgInsuranceClaimnsProgress: boolean;

  MyInsurancePolicyClass: InsurancePolicyClass[];
  dsMyInsurancePolicyClass: MatTableDataSource<InsurancePolicyClass>;

  MyFullInsurancePolicyClass: InsurancePolicyClass[];
  dsMyFullInsurancePolicyClass: MatTableDataSource<InsurancePolicyClass>;

  MyInsuranceClaimnsClass: InsuranceclaimsClass[];
  dsMyInsuranceClaimnsClass: MatTableDataSource<InsuranceclaimsClass>;
  dsMyInsuranceClaimnsdisplayedColumns: string[] = [
    'CompaniesShortName',
    'ProductsTypesName',
    'MatriculaCapital',
    'ClaimDate',
    'idInsuranceClaimsStatusTypes',
  ];

  MyFullInsuranceClaimnsClass: InsuranceclaimsClass[];
  dsFullMyInsuranceClaimnsClass: MatTableDataSource<InsuranceclaimsClass>;

  public MySafesimulationsClass: SafesimulationsClass[];
  public dsMySafesimulationsClass: MatTableDataSource<SafesimulationsClass>;
  public dsMySafesimulationsClassdisplayedColumns: string[] = [
    'CompaniesShortName',
    'ProductsTypesName',
    'DateStart',
    'Price',
    'Action',
  ];

  public MyFullSafesimulationsClass: SafesimulationsClass[];
  public dsFullMySafesimulationsClass: MatTableDataSource<SafesimulationsClass>;

  public _dsMySafesimulationsData = new BehaviorSubject<SafesimulationsClass[]>([]);

  constructor(
    private insuranceclaimsService: InsuranceclaimsService,
    private insurancePolicyService: InsurancePolicyService,
    private customerService: CustomerService,
    public globalService: GlobalService,
    private safesimulationsService: SafesimulationsService,
    private dialog: MatDialog,
    public authService: AuthService,
    private ageasService: AgeasService,
    private productsService: ProductsService,
    private commonService: CommonService,
    private alerts: AlertMessageService,
    private networkStatusService: NetworkStatusService,
    private alert: AlertService,
    private router: Router,
  ) {
    this.dsMySafesimulationsClass = new MatTableDataSource<SafesimulationsClass>([]);
    this.dsMyInsurancePolicyClass = new MatTableDataSource<InsurancePolicyClass>([]);
    this.dsMyInsuranceClaimnsClass = new MatTableDataSource<InsuranceclaimsClass>([]);
  }

  public ageFromDateOfBirthday(dateOfBirth: any): number {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }

  updateSafesimulationsData(data: SafesimulationsClass[]) {
    this._dsMySafesimulationsData.next(data);
  }

  /** Limpa todos os dados em memória (útil para troca de perfil) */
  clearAllData() {
    this.MyInsurancePolicyClass = [];
    this.MyFullInsurancePolicyClass = [];
    this.MyInsuranceClaimnsClass = [];
    this.MyFullInsuranceClaimnsClass = [];
    this.MySafesimulationsClass = [];
    this.MyFullSafesimulationsClass = [];

    if (this.dsMyInsurancePolicyClass) this.dsMyInsurancePolicyClass.data = [];
    if (this.dsMyFullInsurancePolicyClass) this.dsMyFullInsurancePolicyClass.data = [];
    if (this.dsMyInsuranceClaimnsClass) this.dsMyInsuranceClaimnsClass.data = [];
    if (this.dsFullMyInsuranceClaimnsClass) this.dsFullMyInsuranceClaimnsClass.data = [];
    if (this.dsMySafesimulationsClass) this.dsMySafesimulationsClass.data = [];
    if (this.dsFullMySafesimulationsClass) this.dsFullMySafesimulationsClass.data = [];

    this._dsMySafesimulationsData.next([]);
  }

  async addinsuranceclaims(customerClass: CustomerClass, policyClass?: InsurancePolicyClass): Promise<boolean> {
    if (!this.globalService.loggedUserClass?.InsuranceClaimsAdd || !customerClass) {
      console.log('Adição de sinistros não permitida');
      return false; // Retorno false para indicar falha
    }

    this.showWgInsuranceClaimnsProgress = true;

    try {
      const Alertas = await this.CheckDataclient(customerClass);
      const executar = await this.CheckAlertsIfContinue(<Alert[]>Alertas);

      if (!executar) {
        this.showWgInsuranceClaimnsProgress = false;
        return false; // Retorno false para indicar falha
      }

      // Aguarda a conclusão do log antes de prosseguir
      await firstValueFrom(
        this.commonService.SetSiteRoutesLog(
          this.globalService.loggedUserClass.idUser,
          'Sinistros',
          'Adicionar Sinistro',
          this.globalService.loggedUserClass.UUID,
        ),
      );

      // Prepara os dados do sinistro no globalService
      this.globalService.insuranceclaimsClass = new InsuranceclaimsClass();
      this.globalService.insuranceclaimsClass.idCustomer = customerClass.idCustomer;
      this.globalService.insuranceclaimsClass.idInsuranceClaimsStatusTypes =
        this.globalService.commonDefaultsClass?.idInsuranceClaimsStatusTypes;
      this.globalService.insuranceclaimsClass.Contact = customerClass.Contact;
      this.globalService.insuranceclaimsClass.DateStart = dayjs() as any;
      this.globalService.insuranceclaimsClass.TitleForm = 'Sinistro';

      if (policyClass) {
        this.globalService.insuranceclaimsClass.idInsurancePolicy = Number(policyClass.idInsurancePolicy);
        this.globalService.insuranceclaimsClass.PolicyNumber = policyClass.PolicyNumber;
        this.globalService.insuranceclaimsClass.idCompanie = Number(policyClass.idCompanie);
        this.globalService.insuranceclaimsClass.idProduct = policyClass.idProduct
          ? Number(policyClass.idProduct)
          : null;
        this.globalService.insuranceclaimsClass.idProductsTypes = policyClass.idProductsTypes
          ? Number(policyClass.idProductsTypes)
          : null;
        this.globalService.insuranceclaimsClass.Matricula = (
          (policyClass as any).Matricula ||
          (policyClass as any).Registration ||
          (policyClass as any).LicensePlate ||
          ''
        )
          .toString()
          .trim();
      }

      // Navegar para a rota dedicada
      this.router.navigate(['/clientarea/novo-sinistro']);

      this.showWgInsuranceClaimnsProgress = false;
      return true;
    } catch (error) {
      console.error('Erro ao adicionar sinistros:', error);
      Swal.fire('Erro', 'Houve um erro ao processar seu pedido, por favor, tente novamente.', 'error');
      return false;
    } finally {
      this.showWgInsuranceClaimnsProgress = false;
    }
  }

  async refreshInsuranceClaims(customerClass: CustomerClass, silent: boolean = false) {
    // silent=true: refresh silencioso (não esconde a tabela), usado nos refreshes subsequentes
    if (!silent) {
      this.showWgInsuranceClaimnsProgress = true;
    }
    try {
      const customer = customerClass || this.globalService.loggedUserClass?.customerClass;
      const idCustomer = customer?.idCustomer;
      if (!idCustomer) {
        this.MyInsuranceClaimnsClass = [];
        if (!this.dsMyInsuranceClaimnsClass) {
          this.dsMyInsuranceClaimnsClass = new MatTableDataSource<InsuranceclaimsClass>([]);
        } else {
          this.dsMyInsuranceClaimnsClass.data = [];
        }
        return;
      }

      const [claims] = await Promise.all([
        firstValueFrom(this.insuranceclaimsService.ClientAreaGetInsuranceClaimsCustomerALLWidget(idCustomer)),
        this.CheckDatainsuranceclaims(customer),
      ]);

      this.MyInsuranceClaimnsClass = (claims || []).map(c => {
        const claim = Object.assign(new InsuranceclaimsClass(), c);
        claim.parseDates();
        return claim;
      });
      if (!this.dsMyInsuranceClaimnsClass) {
        this.dsMyInsuranceClaimnsClass = new MatTableDataSource<InsuranceclaimsClass>(this.MyInsuranceClaimnsClass);
      } else {
        // Actualização silenciosa: apenas os dados mudam, a tabela permanece visível
        this.dsMyInsuranceClaimnsClass.data = this.MyInsuranceClaimnsClass;
      }
    } catch (error) {
      if (this.networkStatusService.isOnline) {
        this.alerts.error('ERRORS.REQUEST_FAILED', 'COMMON.ALERTS.ATTENTION');
      }
      console.log(error);
    } finally {
      if (!silent) {
        this.showWgInsuranceClaimnsProgress = false;
      }
    }
  }

  async addinsuranceclaimsbreakingglass(customerClass?: CustomerClass): Promise<boolean> {
    if (!this.globalService.loggedUserClass?.InsuranceClaimsAdd) {
      console.log('Adição de sinistros não permitida');
      return false;
    }

    try {
      this.showWgInsuranceClaimnsProgress = true;

      if (customerClass) {
        const Alertas = await this.CheckDataclient(customerClass);
        const executar = await this.CheckAlertsIfContinue(Alertas as Alert[]);

        if (!executar) {
          this.showWgInsuranceClaimnsProgress = false;
          return false;
        }
      }

      await firstValueFrom(
        this.commonService.SetSiteRoutesLog(
          this.globalService.loggedUserClass?.idUser,
          'Sinistros',
          'Adicionar Quebra de vidros',
          this.globalService.loggedUserClass?.UUID,
        ),
      );

      this.showWgInsuranceClaimnsProgress = false;
      this.router.navigate(['/clientarea/participar-sinistro'], {
        queryParams: { tipo: 'vidros' },
      });
      return true;
    } catch (error) {
      this.showWgInsuranceClaimnsProgress = false;
      console.error('Erro ao abrir participação de quebra de vidros:', error);
      this.router.navigate(['/clientarea/participar-sinistro'], {
        queryParams: { tipo: 'vidros' },
      });
      return true;
    } finally {
      this.showWgInsuranceClaimnsProgress = false;
    }
  }

  private _checkDataclientInFlight = new Map<number, Promise<Alert[]>>();
  private _checkAllAlertsInFlight: Promise<Alert[]> | null = null;
  private _lastCheckAllAlertsTime = 0;
  private _lastCheckAllAlertsCustomerId: number | null = null;
  private _lastCheckAllAlertsResult: Alert[] = [];

  CheckDataclient(customerClass: CustomerClass): Promise<Alert[]> {
    const idCustomer = customerClass?.idCustomer;
    if (idCustomer && this._checkDataclientInFlight.has(idCustomer)) {
      return this._checkDataclientInFlight.get(idCustomer)!;
    }

    const promise = new Promise<Alert[]>(resolve => {
      if (!this.authService.isLoggedin(this.globalService.loggedUserClass)) {
        resolve(this.globalService.loggedUserClass?.customerClass?.alertUser || []);
        return;
      }

      try {
        if (!this.globalService.loggedUserClass?.customerClass) {
          console.warn('loggedUserClass.customerClass is undefined - aguardando carregamento');
          resolve([]);
          return;
        }

        // Deferir actualização para evitar ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
          this.globalService.alertGeralMenuUser = new Alert();
          this.globalService.alertGeralMenuUser.bloquear = false;
          this.globalService.alertGeralMenuUser.detail = '';
          this.globalService.alertGeralMenuUser.faltaCC = false;
          this.globalService.alertGeralMenuUser.faltaCartaConducao = false;
          this.globalService.alertGeralMenuUser.message = '';
          this.globalService.alertGeralMenuUser.idkey = null;
          this.globalService.alertGeralMenuUser.typeClass = '';
        });

        this.customerService.ClientAreaCheckDataclient(customerClass?.idCustomer).subscribe({
          next: dados => {
            customerClass.alertUser = dados;
          },
          error: error => {
            console.log(error);
            resolve([]);
          },
          complete: () => {
            try {
              if (customerClass.alertUser) {
                setTimeout(() => {
                  customerClass.alertUser.forEach(element => {
                    if (element.faltaCC) {
                      this.globalService.alertGeralMenuUser.faltaCC = true;
                    }
                    if (element.faltaCartaConducao) {
                      this.globalService.alertGeralMenuUser.faltaCartaConducao = true;
                    }
                    if (element.AlertButon) {
                      this.globalService.alertGeralMenuUser.AlertButon = element.AlertButon;
                    }
                  });
                });
              }
            } catch (error) {}
            resolve(customerClass.alertUser || []);
          },
        });
      } catch (error) {
        console.log(error);
        resolve([]);
      }
    }).finally(() => {
      if (idCustomer) {
        this._checkDataclientInFlight.delete(idCustomer);
      }
    });

    if (idCustomer) {
      this._checkDataclientInFlight.set(idCustomer, promise);
    }
    return promise;
  }

  CheckAlertsIfContinue(alertas: Alert[], supressPopup: boolean = false) {
    return new Promise(resolve => {
      // Protecção defensiva: se alertas for null/undefined, continuar
      if (!alertas || !Array.isArray(alertas)) {
        console.warn('[CheckAlertsIfContinue] alertas é null/undefined, a continuar');
        resolve(true);
        return;
      }

      let valid: boolean = true;
      let missingFields: string[] = [];

      alertas.forEach(element => {
        if (element.bloquear) {
          valid = false;
          if (element.message || element.detail) {
            const m = [element.message, element.detail].filter(x => x).join(': ');
            missingFields.push(`<li>${m}</li>`);
          }
        }
      });

      if (!valid && !supressPopup) {
        let htmlContent = '<div style="text-align: left; margin-top: 10px;">';
        if (missingFields.length > 0) {
          htmlContent +=
            '<p style="margin-bottom: 8px;">Os seus dados pessoais estão incompletos. Verifique os seguintes campos obrigatórios:</p>';
          htmlContent +=
            '<ul style="padding-left: 20px; color: var(--color-dark-blue);">' + missingFields.join('') + '</ul>';
        } else {
          htmlContent += '<p>Os seus dados pessoais estão incompletos, verifique os campos em falta.</p>';
        }
        htmlContent += '</div>';

        this.alerts.errorHtml(htmlContent, 'COMMON.ALERTS.ATTENTION');
      }

      resolve(valid);
    });
  }

  CheckDatainsurance(customerClass: CustomerClass) {
    return new Promise(resolve => {
      if (!this.authService.isLoggedin(this.globalService.loggedUserClass) || !customerClass?.idCustomer) {
        resolve(true);
        return;
      }

      this.insurancePolicyService.ClientAreaCheckDatainsurance(customerClass.idCustomer).subscribe({
        next: dados => (customerClass.alertClientAreaInsurances = dados),
        error: error => {
          console.log(error);
          resolve(true);
        },
        complete: () => {
          resolve(customerClass.alertClientAreaInsurances?.length > 0 ? false : true);
        },
      });
    });
  }

  CheckDatainsuranceclaims(customerClass: CustomerClass) {
    return new Promise(resolve => {
      if (!this.authService.isLoggedin(this.globalService.loggedUserClass) || !customerClass?.idCustomer) {
        resolve(true);
        return;
      }

      this.showWgInsuranceClaimnsProgress = true;

      this.insuranceclaimsService.ClientAreaCheckDatainsuranceclaims(customerClass.idCustomer).subscribe({
        next: dados => (customerClass.alertClientAreaInsurancesClaims = dados),
        error: error => {
          console.log(error);
          resolve(true);
        },
        complete: () => {
          this.showWgInsuranceClaimnsProgress = false;
          resolve(customerClass.alertClientAreaInsurancesClaims?.length > 0 ? false : true);
        },
      });
    });
  }

  CheckDatasafesimulations(customerClass: CustomerClass) {
    return new Promise(resolve => {
      if (!this.authService.isLoggedin(this.globalService.loggedUserClass) || !customerClass?.idCustomer) {
        resolve(true);
        return;
      }

      this.showWgsafesimulationsshowProgress = true;
      this.safesimulationsService.ClientAreaCheckDatasafesimulations(customerClass.idCustomer).subscribe({
        next: dados => (customerClass.alertClientAreaSafeSimulations = dados),
        error: error => {
          this.showWgsafesimulationsshowProgress = false;
          console.log(error);
          resolve(true);
        },
        complete: () => {
          this.showWgsafesimulationsshowProgress = false;
          resolve(customerClass.alertClientAreaSafeSimulations?.length > 0 ? false : true);
        },
      });
    });
  }

  CheckAllAlerts(customerClass: CustomerClass): Promise<Alert[]> {
    const idCustomer = customerClass?.idCustomer;
    if (!idCustomer) {
      return Promise.resolve([]);
    }

    if (this._checkAllAlertsInFlight && this._lastCheckAllAlertsCustomerId === idCustomer) {
      return this._checkAllAlertsInFlight;
    }

    const now = Date.now();
    if (
      this._lastCheckAllAlertsCustomerId === idCustomer &&
      now - this._lastCheckAllAlertsTime < 5000 &&
      customerClass.alertUser !== undefined
    ) {
      return Promise.resolve(this._lastCheckAllAlertsResult);
    }

    this._lastCheckAllAlertsCustomerId = idCustomer;
    this._checkAllAlertsInFlight = new Promise<Alert[]>(async resolve => {
      try {
        // Limpar arrays antes de re-buscar para evitar acumulação entre chamadas
        customerClass.alertUser = [];
        customerClass.alertClientAreaInsurances = [];
        customerClass.alertClientAreaInsurancesClaims = [];
        customerClass.alertClientAreaSafeSimulations = [];

        const p1 = this.CheckDataclient(customerClass);
        const p2 = this.CheckDatainsurance(customerClass);
        const p3 = this.CheckDatainsuranceclaims(customerClass);
        const p4 = this.CheckDatasafesimulations(customerClass);

        await Promise.all([p1, p2, p3, p4]);

        const allAlerts: Alert[] = [
          ...(customerClass.alertUser ?? []),
          ...(customerClass.alertClientAreaInsurances ?? []),
          ...(customerClass.alertClientAreaInsurancesClaims ?? []),
          ...(customerClass.alertClientAreaSafeSimulations ?? []),
        ];

        this._lastCheckAllAlertsResult = allAlerts;
        this._lastCheckAllAlertsTime = Date.now();
        resolve(allAlerts);
      } finally {
        this._checkAllAlertsInFlight = null;
      }
    });

    return this._checkAllAlertsInFlight;
  }

  async refreshsafesimulationsClass(customerClass: CustomerClass) {
    const customer = customerClass || this.globalService.loggedUserClass?.customerClass;
    if (!customer?.idCustomer) {
      return;
    }
    this.showWgsafesimulationsshowProgress = true;
    try {
      const [claims] = await Promise.all([
        firstValueFrom(this.safesimulationsService.ClientAreaGetSafeSimulationsCustomerAllWidget(customer.idCustomer)),
        this.CheckDatasafesimulations(customer),
      ]);

      this.MySafesimulationsClass = claims;
      if (!this.dsMySafesimulationsClass) {
        this.dsMySafesimulationsClass = new MatTableDataSource(this.MySafesimulationsClass);
      } else {
        this.dsMySafesimulationsClass.data = this.MySafesimulationsClass;
      }
      this.updateSafesimulationsData(this.MySafesimulationsClass);
    } catch (error) {
      console.log(error);
    } finally {
      this.showWgsafesimulationsshowProgress = false;
    }
  }

  ClientAreaGetCustomerShipToAddress(idCustomer: number) {
    try {
      if (idCustomer) {
        this.customerService.ClientAreaGetCustomerShipToAddress(idCustomer).subscribe({
          next: dados => {
            if (this.globalService.loggedUserClass?.customerClass) {
              this.globalService.loggedUserClass.customerClass.customerShipToAddressClass = dados;
            }
          },
          error: error => console.log(error),
        });
      }
    } catch (error) {}
  }

  async uploadFileInsuranceClaims(
    insuranceclaimsClass: InsuranceclaimsClass,
    save: boolean,
    customerClass: CustomerClass,
  ) {
    let uploadFilesClass: UploadFilesClass;
    uploadFilesClass = new UploadFilesClass();
    uploadFilesClass.TitleForm = 'Anexar Documentos';
    uploadFilesClass.FolderName = 'insuranceclaims';
    uploadFilesClass.maxAllowedfiles = environment.maxAllowedfiles;
    uploadFilesClass.idCustomer = insuranceclaimsClass.idCustomer;
    uploadFilesClass.NIF = insuranceclaimsClass.NIF;
    uploadFilesClass.idProduct = insuranceclaimsClass.idProduct;
    uploadFilesClass.idProductsTypes = insuranceclaimsClass.idProductsTypes;

    this.insuranceclaimsService.ClientAreaGetInsuranceClaimsFiles(insuranceclaimsClass.idInsuranceClaims).subscribe({
      next: files => {
        insuranceclaimsClass.insuranceClaimsFiles = files;
        uploadFilesClass.filesClass = files;
      },
      error: error => {
        if (this.networkStatusService.isOnline) {
          this.alerts.error('ERRORS.REQUEST_FAILED', 'COMMON.ALERTS.ATTENTION');
        }
        console.log(error);
      },
      complete: async () => {
        window.history.pushState(null, null, window.location.href);
        let dialogRef: any;
        const { DocumentsComponent } = await import('src/app/shared/components/documents/documents.component');
        if (this.globalService.isMobileDevice) {
          dialogRef = this.dialog.open(DocumentsComponent, {
            data: uploadFilesClass,
            maxWidth: '100vw',
            height: '100%',
            width: '100%',
          });
        } else {
          dialogRef = this.dialog.open(DocumentsComponent, { data: uploadFilesClass });
        }
        dialogRef.autoFocus = true;
        dialogRef.disableClose = true;

        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            insuranceclaimsClass.insuranceClaimsFiles = result;

            if (save) {
              insuranceclaimsClass.UUIDLastChange = this.globalService.loggedUserClass?.UUID;
              this.insuranceclaimsService
                .ClientAreaSetInsuranceClaims(insuranceclaimsClass, this.globalService.loggedUserClass?.UUID)
                .subscribe({
                  error: error => {
                    if (this.networkStatusService.isOnline) {
                      this.alert.showRequestFailed();
                    }
                    console.log(error);
                  },
                  complete: () => {
                    this.refreshInsuranceClaims(customerClass);
                  },
                });
            }
          }
        });
      },
    });
  }

  public uploadFileInsurancePolicy(
    insurancePolicyClass: InsurancePolicyClass,
    save: boolean,
    customerClass: CustomerClass,
  ): Promise<FilesClass[]> {
    return new Promise<FilesClass[]>(resolve => {
      if (!insurancePolicyClass) {
        console.log('Sem informação da apólice');
        resolve([]);
        return;
      }

      const uploadFilesClass = new UploadFilesClass();
      uploadFilesClass.TitleForm = 'Anexar Documentos';
      uploadFilesClass.FolderName = 'insurancepolicy';
      uploadFilesClass.maxAllowedfiles = environment.maxAllowedfiles;
      uploadFilesClass.idCompanie = Number(insurancePolicyClass.idCompanie || 0) || null;
      uploadFilesClass.idCustomer = insurancePolicyClass.idCustomer;
      const policyNif = String(insurancePolicyClass.NIF ?? '').trim();
      const customerNif = String(customerClass?.NIF ?? '').trim();
      uploadFilesClass.NIF = policyNif !== '' ? policyNif : customerNif;
      const policyCustomerName = String(insurancePolicyClass.CustomerName ?? '').trim();
      const fallbackCustomerName = String(customerClass?.Name ?? (insurancePolicyClass as any)?.Name ?? '').trim();
      uploadFilesClass.customerName = policyCustomerName !== '' ? policyCustomerName : fallbackCustomerName;
      uploadFilesClass.policyNumber = String(insurancePolicyClass.PolicyNumber ?? '').trim();
      uploadFilesClass.idInsurancePolicy = insurancePolicyClass.idInsurancePolicy;
      uploadFilesClass.idProduct = insurancePolicyClass.idProduct;
      uploadFilesClass.idProductsTypes = insurancePolicyClass.idProductsTypes;
      if (window.location.href.includes('intermediary') || window.location.href.includes('mediador')) {
        uploadFilesClass.contextType = 'intermediaryarea';
      }

      insurancePolicyClass.loading = true;

      this.insurancePolicyService
        .ClientAreaGetInsurancePolicyFiles(insurancePolicyClass.idInsurancePolicy, { forceRefresh: true })
        .subscribe({
          next: files => {
            const safeFiles = Array.isArray(files) ? files : [];
            insurancePolicyClass.insurancePolicyFilesClass = safeFiles;
            uploadFilesClass.filesClass = [...safeFiles];

            const openDialog = async () => {
              window.history.pushState(null, null, window.location.href);

              const dialogConfig: any = {
                data: uploadFilesClass,
                autoFocus: true,
                disableClose: true,
                width: '800px',
                maxWidth: '90vw',
                panelClass: 'sv-compact-dialog',
              };

              if (this.globalService.isMobileDevice) {
                dialogConfig.maxWidth = '100vw';
                dialogConfig.height = '100%';
                dialogConfig.width = '100%';
              }

              const { DocumentsComponent } = await import('src/app/shared/components/documents/documents.component');
              const dialogRef = this.dialog.open(DocumentsComponent, dialogConfig);

              dialogRef.afterClosed().subscribe(result => {
                insurancePolicyClass.loading = false;

                if (result) {
                  const filteredResult: FilesClass[] = result
                    .filter(item => !item.VirtualDoc)
                    .map(item => {
                      if (!item.idInsurancePolicy) {
                        item.idInsurancePolicy = insurancePolicyClass.idInsurancePolicy;
                      }
                      if (!item.idCustomer) {
                        item.idCustomer = insurancePolicyClass.idCustomer;
                      }
                      return item;
                    });
                  insurancePolicyClass.insurancePolicyFilesClass = filteredResult;

                  if (save) {
                    const userUuid = this.globalService.loggedUserClass?.UUID;
                    insurancePolicyClass.UUIDLastChange = userUuid;
                    this.insurancePolicyService.ClientAreaSetInsurancePolicy(insurancePolicyClass, userUuid).subscribe({
                      complete: () => {
                        if (
                          customerClass?.idCustomer &&
                          !window.location.href.includes('intermediary') &&
                          !window.location.href.includes('mediador')
                        ) {
                          this.refreshInsurancePolicy(customerClass);
                        }
                        resolve(filteredResult);
                      },
                      error: err => {
                        console.warn(
                          '[uploadFileInsurancePolicy] Fallback para gravação direta de ficheiros (ClientAreaSetInsurancePolicyFile):',
                          err,
                        );
                        const savePromises = filteredResult.map(
                          f =>
                            new Promise<void>(resFile => {
                              this.insurancePolicyService.ClientAreaSetInsurancePolicyFile(f).subscribe({
                                next: () => resFile(),
                                error: () => resFile(),
                              });
                            }),
                        );
                        Promise.all(savePromises).then(() => {
                          if (
                            customerClass?.idCustomer &&
                            !window.location.href.includes('intermediary') &&
                            !window.location.href.includes('mediador')
                          ) {
                            this.refreshInsurancePolicy(customerClass);
                          }
                          resolve(filteredResult);
                        });
                      },
                    });
                  } else {
                    resolve(filteredResult);
                  }
                } else {
                  resolve(insurancePolicyClass.insurancePolicyFilesClass || []);
                }
              });
            };

            switch (Number(insurancePolicyClass.idCompanie)) {
              case 2:
                this.ageasService
                  .getAgeasPolicyDocuments(insurancePolicyClass)
                  .then(() => {
                    uploadFilesClass.filesClass = [...(insurancePolicyClass.insurancePolicyFilesClass || [])];
                    openDialog();
                  })
                  .catch(error => {
                    console.warn('[uploadFileInsurancePolicy] Aviso ao obter documentos AGEAS:', error);
                    openDialog();
                  });
                break;

              case 3:
                let produto: ProductsTypesClass;
                this.productsService
                  .GetProductsType(insurancePolicyClass.idProduct, insurancePolicyClass.idProductsTypes)
                  .subscribe({
                    next: prod => (produto = Array.isArray(prod) ? prod[0] : prod),
                    error: err => {
                      console.error(err);
                      openDialog();
                    },
                    complete: () => {
                      this.insurancePolicyService
                        .ClientAreaGetInsurancePolicyReceipts(
                          insurancePolicyClass.idCustomer,
                          insurancePolicyClass.idInsurancePolicy,
                        )
                        .subscribe({
                          next: recibos => {
                            const rawRecibos = Array.isArray(recibos) ? recibos.filter(Boolean) : [];
                            const uniqueRecibosMap = new Map<string, any>();
                            for (const r of rawRecibos) {
                              const key = String(
                                r.receiptNumber || r.idInsurancePolicyReceipts || Math.random(),
                              ).trim();
                              const existing = uniqueRecibosMap.get(key);
                              if (!existing) {
                                uniqueRecibosMap.set(key, r);
                              } else {
                                const currentHasDate = Boolean(r.emissionDate || r.startDate || r.DateStart);
                                const existingHasDate = Boolean(
                                  existing.emissionDate || existing.startDate || existing.DateStart,
                                );
                                if (currentHasDate && !existingHasDate) {
                                  uniqueRecibosMap.set(key, r);
                                }
                              }
                            }
                            const safeRecibos = Array.from(uniqueRecibosMap.values());

                            const receiptDocuments = safeRecibos.map(recibo => {
                              const rawDate = recibo.emissionDate || recibo.startDate || recibo.DateStart;
                              const parsedDate = rawDate ? new Date(rawDate) : null;
                              const validDate =
                                parsedDate && !isNaN(parsedDate.getTime()) && parsedDate.getFullYear() > 1970
                                  ? parsedDate
                                  : null;
                              const doc = new FilesClass();
                              Object.assign(doc, {
                                idInsurancePolicy: recibo.idInsurancePolicy || insurancePolicyClass.idInsurancePolicy,
                                idCustomer: recibo.idCustomer || insurancePolicyClass.idCustomer,
                                idCompanie: Number(recibo.idCompanie || insurancePolicyClass.idCompanie || 3),
                                idProduct: recibo.idProduct || insurancePolicyClass.idProduct,
                                idProductsTypes: recibo.idProductsTypes || insurancePolicyClass.idProductsTypes,
                                DocumentName: `Recibo Nº ${recibo.receiptNumber ?? ''}`.trim(),
                                Description: `Recibo Nº ${recibo.receiptNumber ?? ''}`.trim(),
                                PolicyNumber: insurancePolicyClass.PolicyNumber || recibo.PolicyNumber,
                                NrRecibo: recibo.receiptNumber ?? '',
                                ValorRecibo: (recibo?.premium ?? recibo?.amountReceipt)?.toString() ?? '',
                                Tipo: '',
                                type: 'application/pdf',
                                DateStart: validDate,
                                updated: validDate,
                                Tabulador: 'Recibo',
                                FilePath: 'Recibo',
                                VirtualDoc: true,
                                ManagedBySegurosVirtual: recibo.ManagedBySegurosVirtual,
                              });
                              return doc;
                            });

                            uploadFilesClass.filesClass.push(...receiptDocuments);

                            if (produto?.CartaVerde) {
                              const cartaVerdeDocuments = safeRecibos.map(recibo => {
                                const rawDate = recibo.emissionDate || recibo.startDate || recibo.DateStart;
                                const parsedDate = rawDate ? new Date(rawDate) : null;
                                const validDate =
                                  parsedDate && !isNaN(parsedDate.getTime()) && parsedDate.getFullYear() > 1970
                                    ? parsedDate
                                    : null;
                                const doc = new FilesClass();
                                Object.assign(doc, {
                                  idInsurancePolicy: recibo.idInsurancePolicy || insurancePolicyClass.idInsurancePolicy,
                                  idCustomer: recibo.idCustomer || insurancePolicyClass.idCustomer,
                                  idCompanie: Number(recibo.idCompanie || insurancePolicyClass.idCompanie || 3),
                                  idProduct: recibo.idProduct || insurancePolicyClass.idProduct,
                                  idProductsTypes: recibo.idProductsTypes || insurancePolicyClass.idProductsTypes,
                                  DocumentName: `Carta Verde Nº ${recibo.receiptNumber ?? ''}`.trim(),
                                  Description: `Carta Verde Nº ${recibo.receiptNumber ?? ''}`.trim(),
                                  PolicyNumber: insurancePolicyClass.PolicyNumber || recibo.PolicyNumber,
                                  NrRecibo: recibo.receiptNumber ?? '',
                                  ValorRecibo: (recibo?.premium ?? recibo?.amountReceipt)?.toString() ?? '',
                                  Tipo: '',
                                  type: 'application/pdf',
                                  DateStart: validDate,
                                  updated: validDate,
                                  Tabulador: 'CartaVerde',
                                  FilePath: 'CartaVerde',
                                  VirtualDoc: true,
                                  ManagedBySegurosVirtual: recibo.ManagedBySegurosVirtual,
                                });
                                return doc;
                              });

                              uploadFilesClass.filesClass.push(...cartaVerdeDocuments);
                            }

                            openDialog();
                          },
                          error: err => {
                            console.warn('[uploadFileInsurancePolicy] Aviso ao obter recibos da apólice:', err);
                            openDialog();
                          },
                        });
                    },
                  });
                break;

              default:
                openDialog();
                break;
            }
          },
          error: error => {
            insurancePolicyClass.loading = false;
            if (this.networkStatusService.isOnline) {
              this.alerts.error('ERRORS.REQUEST_FAILED', 'COMMON.ALERTS.ATTENTION');
            }
            console.error(error);
            resolve([]);
          },
        });
    });
  }

  public async refreshInsurancePolicy(customerClass: CustomerClass, silent: boolean = false) {
    // silent=true: refresh silencioso (não esconde a tabela), usado nos refreshes subsequentes
    if (!silent) {
      this.showProgressWginsurancepolicy = true;
    }

    try {
      const customer = customerClass || this.globalService.loggedUserClass?.customerClass;
      const idCustomer = customer?.idCustomer;

      if (!idCustomer) {
        console.warn('[ClientArea] idCustomer não disponível para refreshInsurancePolicy');
        this.MyInsurancePolicyClass = [];
        if (!this.dsMyInsurancePolicyClass) {
          this.dsMyInsurancePolicyClass = new MatTableDataSource([]);
        } else {
          this.dsMyInsurancePolicyClass.data = [];
        }
        return;
      }

      // Paralelizar o carregamento de dados e a verificação de alertas
      const [InsurancePolicy] = await Promise.all([
        firstValueFrom(this.insurancePolicyService.ClientAreaGetInsurancePolicyCustomerAll(idCustomer)),
        this.CheckDatainsurance(customer),
      ]);

      this.MyInsurancePolicyClass = InsurancePolicy || [];
      if (!this.dsMyInsurancePolicyClass) {
        this.dsMyInsurancePolicyClass = new MatTableDataSource(this.MyInsurancePolicyClass);
      } else {
        // Actualização silenciosa: apenas os dados mudam, a tabela permanece visível
        this.dsMyInsurancePolicyClass.data = this.MyInsurancePolicyClass;
      }
    } catch (error) {
      if (this.networkStatusService.isOnline) {
        this.alerts.error('ERRORS.REQUEST_FAILED', 'COMMON.ALERTS.ATTENTION');
      }
      console.log(error);
    } finally {
      this.showProgressWginsurancepolicy = false;
    }
  }

  public initInsurancePolicy(insurancepolicy: InsurancePolicyClass) {
    // só podo ter valores gerais esta função é invocada em vários ecrãs
    insurancepolicy.idInsurancePolicy = null;
    insurancepolicy.idCustomer = null;
    insurancepolicy.CustomerName = '';
    insurancepolicy.idCompanie = null;
    insurancepolicy.CompanieName = '';
    insurancepolicy.CompaniesShortName = '';
    insurancepolicy.idProduct = null;
    insurancepolicy.ProductName = '';
    insurancepolicy.ProductShortName = '';
    insurancepolicy.idProductsTypes = null;
    insurancepolicy.ProductsTypesName = '';
    insurancepolicy.ProductsTypesShortName = '';
    insurancepolicy.idPaymentsTypes = null;
    insurancepolicy.idPaymentsSplit = null;
    insurancepolicy.PaymentsSplitDescription = '';
    insurancepolicy.idInsurancePolicyStatusTypes =
      this.globalService.commonDefaultsClass?.idInsurancePolicyStatusTypes || 1;
    insurancepolicy.InsurancePolicyStatusTypesDescription = '';
    insurancepolicy.InsurancePolicyStatusTypesBackground = '';
    insurancepolicy.InsurancePolicyStatusTypesTextColor = '';
    insurancepolicy.IconURLStatus = '';
    insurancepolicy.ProductsIcon = null;
    insurancepolicy.idCommercial = null;
    insurancepolicy.CommercialName = '';
    insurancepolicy.idBillingAddress = null;
    insurancepolicy.idShipToAddress = null;
    insurancepolicy.AddressDetail = '';
    insurancepolicy.PostalCode = '';
    insurancepolicy.Region = '';
    insurancepolicy.PolicyNumber = '';
    insurancepolicy.Description = '';
    insurancepolicy.Matricula = '';
    insurancepolicy.MatriculaDados = '';
    insurancepolicy.Capital = null;
    insurancepolicy.Salario = null;
    insurancepolicy.CreatedByUser = null;
    insurancepolicy.DateStartPolicy = new Date();
    insurancepolicy.DateEndPolicy = null;
    insurancepolicy.renewalDate = null;
    insurancepolicy.NIB = '';
    insurancepolicy.Price = null;
    insurancepolicy.AcceptContract = false;
    insurancepolicy.AcceptRGPD = false;
    insurancepolicy.DateStart = new Date();
    insurancepolicy.DateEnd = null;
    insurancepolicy.ReceiveAlerts = false;
    insurancepolicy.Newsletter = false;
    insurancepolicy.GestaoEmailWhatsAp = false;
    insurancepolicy.AceitoTransferenciaSeguro = false;

    insurancepolicy.SendSMS = this.globalService.commonDefaultsClass?.SendSMS;
    insurancepolicy.SendSMSDays = this.globalService.commonDefaultsClass?.SendSMSDays;
    insurancepolicy.SendEmail = this.globalService.commonDefaultsClass?.SendEmail;
    insurancepolicy.SendEmailDays = this.globalService.commonDefaultsClass?.SendEmailDays;

    insurancepolicy.SendWhatsApp = this.globalService.commonDefaultsClass?.SendWhatsApp;
    insurancepolicy.SendWhatsAppDays = this.globalService.commonDefaultsClass?.SendWhatsAppDays;

    insurancepolicy.SendSMSInspecAuto = this.globalService.commonDefaultsClass?.SendSMSInspecAuto;

    insurancepolicy.SendSMSDaysInspecAuto = this.globalService.commonDefaultsClass?.SendSMSDaysInspecAuto;
    insurancepolicy.SendEmailInspecAuto = this.globalService.commonDefaultsClass?.SendEmailInspecAuto;
    insurancepolicy.SendEmailDaysInspecAuto = this.globalService.commonDefaultsClass?.SendEmailDaysInspecAuto;

    insurancepolicy.SendWhatsAppInspecAuto = this.globalService.commonDefaultsClass?.SendWhatsAppInspecAuto;
    insurancepolicy.SendWhatsAppDaysInspecAuto = this.globalService.commonDefaultsClass?.SendWhatsAppDaysInspecAuto;

    insurancepolicy.Signature = '';
    insurancepolicy.UUID = '';
    insurancepolicy.insurancePolicyFilesClass = [];
    insurancepolicy.UUIDLastChange = '';
    insurancepolicy.TitleForm = '';

    insurancepolicy.files = null;
    insurancepolicy.ManagedBySegurosVirtual = false;

    insurancepolicy.ShowMatricula = false;
    insurancepolicy.ShowCapital = false;
    insurancepolicy.ShowSalario = false;
    insurancepolicy.isProduct = false;
    insurancepolicy.ShowCarInspection = false;
    insurancepolicy.ShowInsuranceClaimsCausesTypes = false;
    insurancepolicy.Order = null;
    insurancepolicy.isHealthInsurance = false;
  }

  async addinsuranceclaimsNotification(customerClass: CustomerClass) {
    if (!this.globalService.loggedUserClass?.InsuranceClaimsAdd || !customerClass) {
      return;
    }

    this.showWgInsuranceClaimnsProgress = true;

    try {
      const Alertas = await this.CheckDataclient(customerClass);
      const executar = await this.CheckAlertsIfContinue(<Alert[]>Alertas);

      if (!executar) {
        this.showWgInsuranceClaimnsProgress = false;
        return;
      }

      await firstValueFrom(
        this.commonService.SetSiteRoutesLog(
          this.globalService.loggedUserClass.idUser,
          'Sinistros',
          'Participar Sinistro',
          this.globalService.loggedUserClass.UUID,
        ),
      );

      let insuranceclaimsClass = new InsuranceclaimsClass();
      insuranceclaimsClass.idInsuranceClaims = null;
      insuranceclaimsClass.idInsurancePolicy = null;
      insuranceclaimsClass.Matricula = '';
      insuranceclaimsClass.idCustomer = customerClass.idCustomer;
      insuranceclaimsClass.nome = customerClass.Name;
      insuranceclaimsClass.idCompanie = null;
      insuranceclaimsClass.idInsuranceClaimsCausesTypes = null;
      insuranceclaimsClass.idInsuranceClaimsStatusTypes =
        this.globalService.commonDefaultsClass?.idInsuranceClaimsStatusTypes;
      insuranceclaimsClass.Contact = customerClass.Contact;
      insuranceclaimsClass.Description = '';
      insuranceclaimsClass.ClaimDate = new Date();
      insuranceclaimsClass.Reason = null;
      insuranceclaimsClass.DateStart = new Date();
      insuranceclaimsClass.DateEnd = null;
      insuranceclaimsClass.TitleForm = 'Participar Sinistro';
      insuranceclaimsClass.insuranceClaimsFiles = [];

      this.showWgInsuranceClaimnsProgress = false;

      window.history.pushState(null, null, window.location.href);

      const dialogConfig: any = {
        data: insuranceclaimsClass,
        width: '1200px',
        maxWidth: '95vw',
        maxHeight: '92vh',
        autoFocus: true,
        disableClose: true,
      };

      if (this.globalService.isMobileDevice) {
        dialogConfig.maxWidth = '100vw';
        dialogConfig.height = '100%';
        dialogConfig.width = '100%';
      }

      const { InsuranceClaimNotificationComponent } =
        await import('src/app/pages/clientarea/insuranceclaims/insurance-claim-notification/insurance-claim-notification.component');
      const dialogRef = this.dialog.open(InsuranceClaimNotificationComponent, dialogConfig);

      const result: any = await firstValueFrom(dialogRef.afterClosed());

      await this.refreshInsuranceClaims(customerClass);
      window.history.replaceState(null, null, window.location.href);

      if (result && result.action === 'view_claim' && result.claimId) {
        this.router.navigate(['/clientarea/consultar-sinistro', Number(result.claimId)]);
      }
    } catch (error) {
      console.error('Erro ao participar sinistro:', error);
    } finally {
      this.showWgInsuranceClaimnsProgress = false;
    }
  }
}
